// extracted by mini-css-extract-plugin
module.exports = {"empty":"styles_empty__3qMfo","table":"styles_table__VdxIi","card":"styles_card__2kkhM"};